import React, { useContext } from 'react';

import Typography from '@mui/material/Typography';

import { customFrequencyUtils } from 'app-components/flux/scheduled-transactions';
import QChoiceChips from 'components/QuickenControls/QChoiceChips';
import Monthly from './Monthly';
import { FrequencyContext } from './state';

import { makeStyles } from 'tss-react/mui';

const { CHIP_MONTHS } = customFrequencyUtils;

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  monthlySection: {
    marginTop: theme.spacing(3),
  },
  freqDescription: {
    marginBottom: theme.spacing(2),
    fontSize: 12,
  },
  requiredFont: {
    color: theme.palette.error.main,
    paddingTop: 4,
  },
}));

const Yearly = () => {
  const { dispatch, state, error } = useContext(FrequencyContext);
  const { classes } = useStyles();

  // @ts-expect-error FIXME TS7006
  const handleMonthChange = (selectedItems) => {
    // @ts-expect-error FIXME TS7006
    const selectedMonths = selectedItems?.length > 0 ? selectedItems.map((item) => item.value) : undefined;
    dispatch({ type: 'UPDATE_YEARLY_MONTHS', payload: { months: selectedMonths } });
  };

  const selectedMonths = CHIP_MONTHS.filter((item) => (state.byMonth ? state.byMonth.indexOf(item.value) >= 0 : false));

  return (
    <div id='yearly-recurrence' data-testid='yearly-recurrence' className={classes.root}>
      <Typography className={classes.freqDescription}>Select one or multiple months.</Typography>

      <div data-testid='yearly-months'>
        <QChoiceChips
          items={CHIP_MONTHS}
          selectedItems={selectedMonths}
          labelFromItem={(item) => item.label}
          keyFromItem={(item) => item.value}
          multiple
          onSelected={handleMonthChange}
        />
      </div>
      {error && selectedMonths?.length === 0 && (
        <Typography variant='captionRegular' className={classes.requiredFont}>
          At least one selection is required.
        </Typography>
      )}
      <div className={classes.monthlySection}>
        <Monthly />
      </div>
    </div>
  );
};

export default Yearly;
